// Card #2301 — see DEFAULT_CLOCK_BAR_COLOR below. Same "already on the
// wire for every route" bundle-cost reasoning ScoreboardFrame.jsx's header
// comment gives for its own "brand" import: this is a plain JS constant
// lookup, not a MUI theme construction.
import { colors } from "brand";

// Card #1798 — pulled out of ScoreboardFrame.jsx into its own module so
// ScoreboardErrorBoundary.jsx can use the SAME background color without a
// duplicated hex literal (#1798 judge finding) or a circular import: as of
// #1798, ScoreboardFrame nests a content-level ScoreboardErrorBoundary
// AROUND `children` (so a content throw keeps the frame/clock/banner up),
// which means ScoreboardFrame.jsx now imports ScoreboardErrorBoundary.jsx —
// a boundary that imported this same constant back FROM ScoreboardFrame.jsx
// would be a two-file import cycle. ScoreboardFrame.jsx re-exports this so
// "export DEFAULT_BACKGROUND_COLOR from ScoreboardFrame.jsx" still holds for
// any other consumer, while ScoreboardErrorBoundary imports it from here
// directly, breaking the cycle.
export const DEFAULT_BACKGROUND_COLOR = "#0b0b0f";

// Card #2301 — the footer banner's own pre-existing appearance
// (ScoreboardFrame.jsx's .scoreboard-frame__footer-banner, previously a
// hardcoded inline `colors.foxBlue`), pulled out here alongside
// DEFAULT_BACKGROUND_COLOR so ScoreboardFrame.jsx's themeCssVars can fall
// back to the EXACT color already shipping today, whether a theme is
// missing the field entirely (predates this card) or explicitly carries
// clockBarColor: null (a venue that never customized it). NOT the
// VenueClock.css pill's old rgba(0,0,0,0.4) — that pill has been
// unreachable since #1946 moved the clock inside the footer banner, whose
// higher-specificity `.scoreboard-frame__footer-banner .venue-clock` rule
// (ScoreboardFrame.css) forces `background: none` on it, so the pill's own
// background has painted nothing on a real board in months. The banner is
// the actual "clock bar" a venue sees.
export const DEFAULT_CLOCK_BAR_COLOR = colors.foxBlue; // #147793
